/* eslint-disable */
"use strict";

var config, service, serviceLavorazioni;
(async () => {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.service_comande || process.env.VUE_APP_service_comande;
  serviceLavorazioni =
    config.service_lavorazioni || process.env.VUE_APP_service_comande;
})();

async function stampaComanda(tipo, chiave, stampa = true, righeAggiunte) {
  const data = {
    tipo,
    chiave,
    stampa,
    righeAggiunte,
  };
  try {
    const response = await fetch(`${service}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    return { status: "error", message: error.message };
  }
}

async function ristampaComanda(idComanda) {
  const data = {
    idComanda,
  };
  try {
    const response = await fetch(`${service}/ristampa`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    return { status: "error", message: error.message };
  }
}

async function stampaPreconto(tipo, chiave, stampa = true) {
  const data = {
    tipo,
    chiave,
    stampa,
  };
  try {
    const response = await fetch(`${service}/preconto`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    return { status: "error", message: error.message };
  }
}

async function stampaFattura(tipo, chiave, cliente, pagamenti, stampa = true) {
  const data = {
    tipo,
    chiave,
    cliente,
    pagamenti,
    stampa,
  };
  try {
    const response = await fetch(`${service}/fattura`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    return { status: "error", message: error.message };
  }
}

async function caricaLavorazione(
  tipo,
  chiave,
  cliente,
  stampa = true,
  righeAggiunte
) {
  const data = {
    tipo,
    chiave,
    cliente,
    stampa,
    righeAggiunte,
  };
  try {
    const response = await fetch(`${serviceLavorazioni}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    return { status: "error", message: error.message };
  }
}

/* async function stampaLavorazione(tipo, chiave, stampa = true, righeAggiunte) {
  const data = {
    tipo,
    chiave,
    stampa,
    righeAggiunte
  }
  try {
    const response = await fetch(`${service}/lavorazioni/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    return { status: 'error', message: error.message }
  }
}
 */
async function identifica() {
  const response = await fetch(`${service}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  return await response.json();
}

export default {
  stampaComanda,
  stampaPreconto,
  stampaFattura,
  caricaLavorazione,
  ristampaComanda,
  // stampaLavorazione,
  identifica,
};
